export default __webpack_public_path__ + "static/media/9.014d91c2.svg";